import { render, staticRenderFns } from "./kosha.vue?vue&type=template&id=0f3a996d"
import script from "./kosha.vue?vue&type=script&lang=js"
export * from "./kosha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f3a996d')) {
      api.createRecord('0f3a996d', component.options)
    } else {
      api.reload('0f3a996d', component.options)
    }
    module.hot.accept("./kosha.vue?vue&type=template&id=0f3a996d", function () {
      api.rerender('0f3a996d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/kosha/kosha.vue"
export default component.exports